import {useMutation} from "@tanstack/react-query";

import {createServiceFunctionMutationOptions} from "./create-service-function.mutation-options";

export function useCreateServiceFunction() {
  return useMutation(createServiceFunctionMutationOptions());
}
